export default "__VITE_ASSET__f215c2ee__"